import { useState } from "react";
import { addDays, parseISO, startOfToday } from "date-fns";
import { machineFormat } from "@medoma/models/date-and-time";
import { Tabs, TabPanel } from "react-aria-components";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { t } from "@lingui/core/macro";
import { useCapacityDailyOverviews } from "@/api/Capacity";
import { deducedError } from "@/Utils/ErrorUtils";
import { DailyOverviewsPanel } from "./DailyOverviewsPanel/DailyOverviewsPanel";
import { CapacityDailyOverview } from "./CapacityDailyOverview";
import styles from "./CapacityOverview.module.scss";

const DAYS_SHOWN = 7;

export const CapacityOverview = () => {
  const [activeDate, setActiveDate] = useState(
    machineFormat(startOfToday(), "yyyy-MM-dd"),
  );

  const {
    data: dailyOverviewsData,
    isPending,
    isError,
    error,
  } = useCapacityDailyOverviews({
    from: startOfToday(),
    to: addDays(startOfToday(), DAYS_SHOWN - 1),
  });

  if (isPending) {
    return <Loading padding={24} message={t`Hämtar kapacitetsöversikt`} />;
  }

  if (isError) {
    return (
      <ErrorMessage
        padding={24}
        message={`${t`Kunde inte hämta kapacitetsöversikt`}. ${deducedError(error)}`}
      />
    );
  }

  return (
    <div className={styles.frame}>
      <Tabs
        className={styles.capacityOverview}
        selectedKey={activeDate}
        onSelectionChange={(key) => setActiveDate(String(key))}
      >
        <DailyOverviewsPanel dailyOverviewsData={dailyOverviewsData} />
        <TabPanel id={activeDate} className={styles.tabPanel}>
          <CapacityDailyOverview date={parseISO(activeDate)} />
        </TabPanel>
      </Tabs>
    </div>
  );
};
